import {
  FilterGroupType,
  FilterRecord,
  FilterType,
  Operator,
} from '@services/core-services/filters/index';

const OperatorAvailability: Record<FilterType, Operator[]> = {
  [FilterType.String]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.Contains,
    Operator.NotContains,
    Operator.StartsWith,
    Operator.EndsWith,
    Operator.IsEmpty,
    Operator.IsNotEmpty,
    Operator.RegexMatch,
  ],
  [FilterType.Number]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.GreaterThan,
    Operator.GreaterThanOrEqualTo,
    Operator.LessThan,
    Operator.LessThanOrEqualTo,
    Operator.Between,
  ],
  [FilterType.Boolean]: [Operator.Equals, Operator.NotEquals],
  [FilterType.Enum]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.In,
    Operator.NotIn,
    Operator.Exists,
    Operator.NotExists,
  ],
  [FilterType.Date]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.Before,
    Operator.After,
    Operator.Between,
    Operator.LastX,
  ],
  [FilterType.DateTime]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.Before,
    Operator.After,
    Operator.Between,
    Operator.LastX,
  ],
  [FilterType.Source]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.In,
    Operator.NotIn,
    Operator.Exists,
    Operator.NotExists,
  ],
  [FilterType.JSON]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.In,
    Operator.NotIn,
    Operator.Exists,
    Operator.NotExists,
  ],
  [FilterType.List]: [
    Operator.Equals,
    Operator.NotEquals,
    Operator.In,
    Operator.NotIn,
    Operator.Exists,
    Operator.NotExists,
  ],
};

export const getAvailableOperators = (record: FilterRecord): Operator[] => {
  if (record.entry.group === FilterGroupType.Events) {
    return [Operator.HasBeenPerformed, Operator.HasNotBeenPerformed];
  }

  return OperatorAvailability[record.entry.type];
};

export const getAvailableOperatorsForEntryType = (type: string) => {
  // @ts-ignore
  return OperatorAvailability[type as string];
};
